import React from "react";
import styled from "@emotion/styled";
import { PublicProject } from "@ecologi/shared";
import { projectTypeVisuals } from "../consts";

const Container = styled.div`
  display: flex;
  text-transform: capitalize;
  align-items: center;
  flex-direction: column;
  min-width: 32px;
  min-height: 32px;
  display: block;
`;

type ImpactTypeIconProps = {
  projectType: NonNullable<PublicProject["projectType"]>;
  className?: string;
};

export const ImpactTypeIcon = ({
  projectType,
  className,
}: ImpactTypeIconProps) => {
  return (
    <Container className={className}>
      {projectTypeVisuals[projectType].icon}
    </Container>
  );
};
